import * as actionTypes from "../ActionTypes";

// 🔹 SAVE CHURCH COVER IMAGE
export const saveChurchCoverImageRequest = ({ apiPayloadRequest, callback }) => ({
  type: actionTypes.SAVE_CHURCH_COVERIMAGE_REQUEST,
  payload: { apiPayloadRequest, callback },
});

export const saveChurchCoverImageSuccess = (data) => ({
  type: actionTypes.SAVE_CHURCH_COVERIMAGE_SUCCESS,
  payload: data,
});

export const saveChurchCoverImageFailure = (error) => ({
  type: actionTypes.SAVE_CHURCH_COVERIMAGE_FAILURE,
  payload: error,
});

// 🔹 UPDATE CHURCH COVER IMAGE
export const updateChurchCoverImageRequest = ({ apiPayloadRequest, callback }) => ({
  type: actionTypes.UPDATE_CHURCH_COVERIMAGE_REQUEST,
  payload: { apiPayloadRequest, callback },
});

export const updateChurchCoverImageSuccess = (data) => ({
  type: actionTypes.UPDATE_CHURCH_COVERIMAGE_SUCCESS,
  payload: data,
});

export const updateChurchCoverImageFailure = (error) => ({
  type: actionTypes.UPDATE_CHURCH_COVERIMAGE_FAILURE,
  payload: error,
});
// 🔹 DELETE CHURCH COVER IMAGE
export const deleteChurchCoverImageRequest = ({ apiPayloadRequest, callback }) => ({
    type: actionTypes.DELETE_CHURCH_COVERIMAGE_REQUEST,
    payload: { apiPayloadRequest, callback },
  });
  
  export const deleteChurchCoverImageSuccess = (data) => ({
    type: actionTypes.DELETE_CHURCH_COVERIMAGE_SUCCESS,
    payload: data,
  });
  
  export const deleteChurchCoverImageFailure = (error) => ({
    type: actionTypes.DELETE_CHURCH_COVERIMAGE_FAILURE,
    payload: error,
  });
  